


























































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import { PushTemplate, CrudDialogMode } from '../utils/types'

@Component
export default class PushTemplateCrud extends Vue {
  @Prop(String) title!: string
  @Prop({ type: Object, default: () => ({}) }) templateItem!: PushTemplate
  @Prop(Number) mode!: CrudDialogMode
  CrudDialogMode = CrudDialogMode

  editedTemplate: Partial<PushTemplate> = this.templatePropData

  @Watch('templateItem')
  onTemplatePropChange() {
    this.editedTemplate = this.templatePropData
  }

  emitClose() {
    this.$emit('close')
  }

  emitSubmit() {
    if (this.isFormVisible) {
      const form = this.$refs.form as Vue & { validate: () => boolean }
      if (!form.validate()) {
        return
      }
    }
    this.$emit('submit', this.editedTemplate)
  }

  get templatePropData(): Partial<PushTemplate> {
    return {
      id: this.templateItem?.id ?? '',
      title: this.templateItem?.title ?? '',
      content: this.templateItem?.content ?? '',
      notes: this.templateItem?.notes ?? '',
      link: this.templateItem?.link ?? '',
      isArchived: this.templateItem?.isArchived ?? false
    }
  }

  get isFormVisible() {
    return (
      this.mode === CrudDialogMode.CREATE || this.mode === CrudDialogMode.EDIT
    )
  }
}
